import type { ProposalEditFormValues } from '../../../Proposal/types';
import {
    buildSalePatch,
    calcAmountWithVat,
    calcSaleRate,
    calcVatAmount,
    formatPrimaryPrice,
    formatRateLine,
    formatTotal,
    getDisplayPrice,
    getFmtRate,
    getIsUahMode,
    getLineTotal,
    getLineTotalWithVat,
    getLineVat,
    getSaleRate,
    getSaleUsd,
    getTotalAmount,
    getTotalVatAmount,
    getUseUsd,
    getVatPercent,
    getVatRate,
    shouldShowRateLine,
} from '../templatePriceUtils';

export const getProposalIsUahMode = getIsUahMode;
export const getProposalUseUsd = getUseUsd;
export const getProposalFmtRate = getFmtRate;
export const getProposalSaleUsd = getSaleUsd;
export const calcProposalSaleRate = calcSaleRate;
export const getProposalSaleRate = getSaleRate;
export const getProposalDisplayPrice = getDisplayPrice;
export const formatProposalPrimaryPrice = formatPrimaryPrice;
export const shouldShowProposalRateLine = shouldShowRateLine;
export const formatProposalRateLine = formatRateLine;
export const getProposalLineTotal = getLineTotal;
export const getProposalLineVat = getLineVat;
export const getProposalLineTotalWithVat = getLineTotalWithVat;
export const buildProposalSalePatch = buildSalePatch;
export const formatProposalTotal = formatTotal;
export const getProposalVatPercent = getVatPercent;
export const getProposalVatRate = getVatRate;
export const calcProposalVatAmount = calcVatAmount;
export const calcProposalAmountWithVat = calcAmountWithVat;
export const getProposalTotalVatAmount = (
    formData: Pick<ProposalEditFormValues, 'products' | 'additionalItems' | 'pricesInUsd' | 'proposalVat'>,
    rate: number,
) =>
    getTotalVatAmount(
        formData.products || [],
        formData.additionalItems || [],
        formData.pricesInUsd,
        rate,
        formData.proposalVat,
    );

export const getProposalTotalAmount = (
    formData: Pick<ProposalEditFormValues, 'products' | 'additionalItems' | 'pricesInUsd' | 'proposalVat'>,
    rate: number,
) =>
    getTotalAmount(
        formData.products || [],
        formData.additionalItems || [],
        formData.pricesInUsd,
        rate,
        formData.proposalVat,
    );

export const getProposalMargin = (formData: Pick<ProposalEditFormValues, 'products' | 'additionalItems' | 'pricesInUsd'>, rate: number) => {
    const sales = getTotalAmount(formData.products || [], formData.additionalItems || [], formData.pricesInUsd, rate);
    const productCost = (formData.products || []).reduce(
        (sum, row) => sum + getLineTotal({ itemCount: row.itemCount, price: row.price }, rate, formData.pricesInUsd),
        0,
    );
    const serviceCost = (formData.additionalItems || []).reduce(
        (sum, row) => sum + (row.serviceId ? getLineTotal({ itemCount: row.itemCount, price: row.price }, rate, formData.pricesInUsd) : 0),
        0,
    );
    const amount = sales - productCost - serviceCost;

    return { amount, percent: sales === 0 ? null : (amount / sales) * 100 };
};
